import { render, staticRenderFns } from "./Ppbkl.vue?vue&type=template&id=1e54aaf1"
import script from "./Ppbkl.vue?vue&type=script&lang=js"
export * from "./Ppbkl.vue?vue&type=script&lang=js"
import style0 from "./Ppbkl.vue?vue&type=style&index=0&id=1e54aaf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports